import { TextInput, type TextInputProps } from "@mantine/core";

import { SYSTEM_COLORS } from "@/configs/colorScheme";

interface FormFieldTextProps extends TextInputProps {}

export const FormFieldText = (props: FormFieldTextProps) => {
  return (
    <TextInput
      variant={props.readOnly ? "unstyled" : undefined}
      placeholder={typeof props.label === "string" ? props.label : undefined}
      withAsterisk={(props.required && !props.readOnly) ?? undefined}
      styles={{
        label: {
          color: props.readOnly ? SYSTEM_COLORS.default : undefined,
        },
      }}
      {...props}
    />
  );
};

export default FormFieldText;
